<template>
<div>
  <v-img src="http://10.0.1.85:3000/administradorUnidade/protected/anuncios/2021-01-13T14-17-53.420Znebula_by_hubble-wallpaper-1366x768.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZEVtcHJlc2EiOjExLCJpZFVuaWRhZGUiOjEsImlkTG9jYWwiOm51bGwsInVzZXJuYW1lIjoiYWRtaW5VbmlkYWRlIiwidGlwbyI6NSwiaWQiOjUsImlhdCI6MTYxMDQ1ODgwNSwiZXhwIjoxNjEwNTQ1MjA1fQ.I2iRqbC4ICpWWDIUn9HNcYZb4V9iO8lAo1WngiLImv4" />
  <beautiful-chat :participants="participants" :title-image-url="titleImageUrl" :on-message-was-sent="onMessageWasSent" :message-list="messageList" :new-messages-count="newMessagesCount" :is-open="isChatOpen" :close="closeChat" :icons="icons" :open="openChat" :show-emoji="true" :show-file="false" :show-typing-indicator="showTypingIndicator" :colors="colors" :always-scroll-to-bottom="alwaysScrollToBottom" :message-styling="messageStyling" @onType="handleOnType" @edit="editMessage" />
</div>
</template>

<script>
import Cookies from 'js-cookie'
import {
  getToken
} from '../../store/auth'

// import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
// import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
// import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
// import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'

export default {
  name: 'EditarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      token: getToken(),
      icons: {
        open: {
          // img: OpenIcon,
          name: 'default'
        },
        close: {
          // img: CloseIcon,
          name: 'default'
        },
        file: {
          // img: FileIcon,
          name: 'default'
        },
        closeSvg: {
          // img: CloseIconSvg,
          name: 'default'
        }
      },
      msg: '',
      context: '',
      botparams: '',
      participants: [{
        id: 'user1',
        name: 'Admin',
        imageUrl: require('../../assets/adminDev/botSimplesmedicCorreto.png')
      } ], // hnet.com-image.ico the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      // titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/.png',
      titleImageUrl: require('../../assets/adminDev/rsz_botsimplesmediccorreto.png'),
      messageList: [
        //   { type: 'text', author: `me`, data: { text: `Olá admin Desenvolvedor!` } },
        //   { type: 'text', author: `user1`, data: { text: `olá !!!` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#44BBAA',
          text: '#ffffff'
        },
        launcher: {
          bg: '#44BBAA'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#44BBAA',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    }
  },
  mounted () {
    this.erroEditar = false,
    this.sucessoEditar = false
    console.log('em chat')
    document.getElementsByClassName('sc-header--title enabled')[0].innerText = 'Bot - SimplesMedic'
    document.getElementsByClassName('sc-user-input--text')[0].attributes.placeholder.value = 'Digite uma mensagem...'
    document.getElementsByClassName('sc-header--title enabled')[0].style.pointerEvents = 'none'

    this.user = this.$store.getters.usuario
    if (this.user.tipo != 10) {
      this.$router.push('/login')
      // return;
    }
  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  },
  methods: {

    clear () {
      this.$refs.form.reset()
    },

    mensagem (text) {
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .mensagem(text, this.context, this.botparams)
        .then(rsp => {
          console.log('rsp oiiiiiiiiiiiii:', rsp.data)
          if (rsp.data == 'erro') {
            this.erroEditar = true
          }
          if (rsp.status == 200) {
            this.botparams = rsp.data.botparams
            this.context = rsp.data.context
            var msg = {
              author: 'user1',
              type: 'text',
              data: {
                text: rsp.data.msg
              }
            }
            this.messageList = [...this.messageList, msg]
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    sendMessage (text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        this.onMessageWasSent({
          author: 'support',
          type: 'text',
          data: {
            text
          }
        })
      }
    },
    onMessageWasSent (message) {
      console.log('formato msg', message)
      // called when the user sends a message
      this.mensagem(message.data.text)
      this.messageList = [...this.messageList, message]
    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage (message) {
      const m = this.messageList.find(m => m.id === message.id)
      m.isEdited = true
      m.data.text = message.data.text
    }
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}

::placeholder {
  color: red;
  opacity: 1;
  /* Firefox */
}
</style>
